
import { cn } from "@/lib/utils"

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "text" | "title" | "avatar" | "card" | "default";
}

function Skeleton({
  className,
  variant = "default",
  ...props
}: SkeletonProps) {
  const variantClasses = {
    text: "skeleton-text",
    title: "skeleton-title",
    avatar: "skeleton-avatar",
    card: "skeleton-card",
    default: "skeleton"
  };

  return (
    <div
      className={cn(variantClasses[variant], className)}
      aria-live="polite"
      aria-busy="true"
      {...props}
    />
  )
}

export { Skeleton }
